import { call } from "../../funcStore";
import { logAction } from "../../api/logApi";
import { recordVtuberView } from "../../utils/userPreference";

const styles = {
  card: {
    display: "flex",
    flexDirection: "column",
    background: "#fff",
    borderRadius: "8px",
    overflow: "hidden",
    textDecoration: "none",
    color: "inherit",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
  },
  thumbnailWrapper: {
    position: "relative",
  },
  thumbnail: {
    width: "100%",
    aspectRatio: "16 / 9",
    objectFit: "cover",
  },
  liveBadge: {
    position: "absolute",
    top: "8px",
    left: "8px",
    background: "#e53935",
    color: "#fff",
    fontSize: "0.7rem",
    fontWeight: "bold",
    borderRadius: "4px",
    padding: "2px 6px",
  },
  body: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    padding: "10px 12px",
  },
  title: {
    margin: 0,
    fontSize: "0.9rem",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  channel: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    padding:10
  },
  channelIcon: {
    width: "30px",
    height: "30px",
    borderRadius: "50%",
    objectFit: "cover",
  },
  channelName: {
    fontSize: "1rem",
    color: "#555",
    overflow: "hidden",          /* 溢れた部分を隠す */
  textOverflow: "ellipsis",   /* 溢れた部分を「...」にする */
  whiteSpace: "nowrap"    
  },
};

function LiveNowCard({ parentKey, itemId }) {
  const item = call(`${parentKey}.getItem`, itemId);

  if (!item) {
    return null;
  }

  const videoUrl = `https://www.youtube.com/watch?v=${item.video_id}`;

  const handleClick = () => {
    recordVtuberView(item.vtuber_id)
    logAction("video_click", {
      vtuberId: item.vtuber_id,
      videoId: item.video_id,
      source: "live_now",
    });
  };

  const navigateVtuberDetail = () => {
    recordVtuberView(item.vtuber_id)
    call("app.navigateToDetail", item.vtuber_id);
  };

  return (
    <div style={styles.card}>
      <a href={videoUrl} target="_blank" rel="noreferrer" onClick={handleClick}>
        <div style={styles.thumbnailWrapper}>
          <img
            style={styles.thumbnail}
            src={item.thumbnail_url.replace("hqdefault", "mqdefault")}
            alt={item.title}
            loading="lazy"
          />
          <span style={styles.liveBadge}>LIVE</span>
        </div>
        <p style={styles.title}>{item.title}</p>
      </a>

      <div style={styles.channel} onClick={navigateVtuberDetail}>
        <img
          style={styles.channelIcon}
          src={item.icon_url}
          alt={item.name}
          loading="lazy"
        />
        <span style={styles.channelName}>{item.name}</span>
      </div>
    </div>
  );
}

export default LiveNowCard;
